import React from 'react';
import { ShieldCheck, Check } from 'lucide-react';
import { HolographicButton } from './HolographicButton';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-warm-100" data-id="element-101">
      <div className="max-w-2xl mx-auto px-4" data-id="element-102">
        <div className="bg-white rounded-3xl shadow-md p-8 md:p-10 relative overflow-hidden" data-id="element-103">
          {/* Decorative Circle */}
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-green-100 rounded-full opacity-50 pointer-events-none" data-id="element-104"></div>

          {/* Shield Seal */}
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center mx-auto mb-5 shadow-lg relative z-10" data-id="element-105">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-106" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-text-dark text-center mb-4 relative z-10" data-id="element-107">
            Garantía Total de 7 Días
          </h2>

          <p className="text-text-body text-center mb-6 relative z-10" data-id="element-108">
            Si el sistema no te sirve, te devolvemos el 100% de tu dinero. Sin
            preguntas, sin letras pequeñas.
          </p>

          <div className="bg-warm-50 border-l-4 border-primary-500 p-5 rounded-r-xl mb-8 relative z-10" data-id="element-109">
            <p className="text-text-dark font-medium text-center md:text-left" data-id="element-110">
              El riesgo real no es comprar esto.
              <span className="text-primary-600 block mt-1 font-semibold" data-id="element-111">
                El riesgo real es otra semana igual.
              </span>
            </p>
          </div>

          {/* Trust Pills */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-8 relative z-10" data-id="element-112">
            <div className="bg-green-50 text-green-700 rounded-full px-3 py-1.5 text-xs font-medium flex items-center gap-1.5" data-id="element-113">
              <Check className="w-3.5 h-3.5" data-id="element-114" /> 100% reembolso
            </div>
            <div className="bg-green-50 text-green-700 rounded-full px-3 py-1.5 text-xs font-medium flex items-center gap-1.5" data-id="element-115">
              <Check className="w-3.5 h-3.5" data-id="element-116" /> Sin preguntas
            </div>
            <div className="bg-green-50 text-green-700 rounded-full px-3 py-1.5 text-xs font-medium flex items-center gap-1.5" data-id="element-117">
              <Check className="w-3.5 h-3.5" data-id="element-118" /> 7 días completos
            </div>
          </div>

          <div className="text-center relative z-10" data-id="element-119">
            <HolographicButton href="#oferta" variant="secondary" size="md" data-id="element-120">
              Probar sin riesgo
            </HolographicButton>
          </div>
        </div>
      </div>
    </section>;
}